import { useQuery } from '@tanstack/react-query';
import { fetchLDClaimsCustomerSettings } from '../data-provider/lad-customer-settings';

export const useGetLADCustomerSettings = (customerKey: number) => {
  return useQuery({
    queryKey: ['claims-loss-and-damage-customer-settings', customerKey],
    queryFn: () => fetchLDClaimsCustomerSettings(),
    enabled: !!customerKey,
  });
};
